import React from 'react';
import { Link } from 'react-router-dom';
import './Solutions.css';

const Solutions: React.FC = () => {
  const solutions = [
    {
      title: '온라인 브랜드 풀필먼트',
      subtitle: 'D2C 브랜드의 주문부터 배송까지 완전한 물류 아웃소싱',
      description: '온라인 쇼핑몰과 D2C 브랜드를 위한 종합 물류 솔루션으로, 주문 접수부터 배송 완료까지 전 과정을 자동화하여 운영합니다.',
      stats: [
        { label: '일 처리 주문량', value: '10,000건+' },
        { label: '주문 처리 시간', value: '2시간 이내' },
        { label: '정시 배송률', value: '98% 이상' }
      ],
      features: [
        '주문 연동: 쇼핑몰/마켓플레이스 API 실시간 연동',
        '자동 출고: 주문 접수 후 2시간 이내 자동 출고 처리',
        '포장 최적화: 브랜드 이미지에 맞는 맞춤 포장',
        '반품 관리: 반품 접수부터 재입고까지 체계적 관리',
        '재고 관리: 실시간 재고 현황 및 자동 재주문 알림',
        '멀티채널: 쿠팡, 11번가, 네이버스마트스토어 등 동시 대응'
      ],
      benefits: [
        '인력 비용 60% 절감',
        '출고 오류율 0.1% 이하',
        '고객 CS 문의 50% 감소'
      ]
    },
    {
      title: '수입브랜드 물류',
      subtitle: '수입 상품의 통관부터 유통까지 원스톱 서비스',
      description: '해외 브랜드의 한국 시장 진출을 위한 완전한 물류 솔루션. CFS 인수부터 통관, 검역, 보관, 상품화, 유통센터 납품까지 전 과정을 책임집니다.',
      stats: [
        { label: '월 처리 물량', value: '500+ 컨테이너' },
        { label: '통관 소요 시간', value: '평균 3일' },
        { label: '검역 통과율', value: '99.5%' }
      ],
      features: [
        '통관 대행: 전문 관세사와 협력한 신속 통관',
        '수입검사: 식품·축산·식물 검역 전문 대응',
        '한글 라벨링: 수입 상품 의무 라벨링 완벽 준수',
        '유통센터 납품: 이마트, 롯데마트, GS리테일 등 스펙 준수',
        'CFS 인수: 평택항 CFS에서 직접 인수하여 리드타임 단축',
        '서류 관리: 수입 관련 모든 서류 일괄 관리 및 보관'
      ],
      benefits: [
        '수입 리드타임 30% 단축',
        '통관 지연률 1% 미만',
        '라벨링 오류 제로'
      ]
    },
    {
      title: 'PB·OEM 유통센터 납품',
      subtitle: '유통센터 입고 스펙을 완벽하게 준수하는 납품 서비스',
      description: '대형 유통센터와 PB/OEM 브랜드의 납품 요구사항을 100% 충족하는 전문 물류 서비스. 라벨링, 포장, 띠지 부착 등 모든 스펙을 정확히 준수합니다.',
      stats: [
        { label: '납품 스펙 준수율', value: '100%' },
        { label: '정시 출고율', value: '98% 이상' },
        { label: '클레임 발생률', value: '0.05% 이하' }
      ],
      features: [
        '스펙 준수: 각 유통센터별 입고 스펙 100% 준수',
        '라벨링 정확도: 바코드, QR코드, 띠지 정확도 99.9%',
        '정시 출고: 약정 일정 준수율 98% 이상',
        '품질 관리: 입고 전 3단계 검수 프로세스',
        '박스 교체: 불량 포장재 자동 교체 시스템',
        '팔레트 작업: 유통센터 요구사항에 맞는 팔레타이징'
      ],
      benefits: [
        '입고 거부율 0.1% 미만',
        '재작업 비용 90% 절감',
        '납품 신뢰도 향상으로 주문량 증가'
      ]
    },
    {
      title: '생활/식품 패키징 솔루션',
      subtitle: '생활용품 및 식품의 전문 패키징 및 상품화 서비스',
      description: '식품 안전과 유통기한 관리를 최우선으로 하는 전문 패키징 서비스. 냉장/냉동 보관부터 상품화, 유통센터 납품까지 콜드체인을 완벽하게 유지합니다.',
      stats: [
        { label: '냉장/냉동 보관', value: '5,200평' },
        { label: '온도 관리 정확도', value: '±0.5℃' },
        { label: '식품 안전 사고', value: '0건' }
      ],
      features: [
        '식품 안전: HACCP 인증 보관 시설 운영',
        '포장 최적화: 제품별 최적 포장재 선정 및 적용',
        '유통기한 관리: FIFO 시스템으로 유통기한 자동 관리',
        '규격 준수: 식품의약품안전처 규격 100% 준수',
        '콜드체인: 보관부터 배송까지 온도 모니터링',
        '검수 시스템: 입고/출고 전 3단계 품질 검수'
      ],
      benefits: [
        '식품 손상률 0.01% 미만',
        '유통기한 관리 오류 제로',
        '고객 만족도 95% 이상'
      ]
    },
    {
      title: '중소기업 물류 아웃소싱',
      subtitle: '중소기업을 위한 맞춤형 물류 아웃소싱 솔루션',
      description: '물류 인프라 구축이 어려운 중소기업을 위한 저비용 고효율 물류 솔루션. 초기 투자 없이 즉시 시작할 수 있으며, 물량에 따라 유연하게 확장 가능합니다.',
      stats: [
        { label: '최소 물량', value: '월 100박스부터' },
        { label: '초기 비용', value: '0원' },
        { label: '비용 절감율', value: '평균 40%' }
      ],
      features: [
        '저비용 구조: 초기 투자 없이 사용한 만큼만 지불',
        '맞춤 설계: 기업 규모와 물량에 맞는 최적 솔루션',
        '유연한 운영: 물량 변동에 따른 즉시 조정 가능',
        '전문 상담: 물류 전문가 1:1 맞춤 상담',
        '간편 연동: 기존 시스템과 쉽게 연동 가능',
        '성장 지원: 기업 성장에 따른 단계적 확장 지원'
      ],
      benefits: [
        '물류 인프라 구축 비용 100% 절감',
        '물류 담당 인력 불필요',
        '핵심 사업에 집중 가능'
      ]
    }
  ];

  return (
    <div className="solutions-page">
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">산업군별 솔루션</h1>
          <p className="page-subtitle">
            다양한 산업군의 특성에 맞춘 전문 물류 솔루션으로 고객의 비즈니스 성장을 지원합니다.
          </p>
          <div className="hero-cta">
            <Link to="/contact" className="btn btn-secondary">
              견적 요청하기
            </Link>
          </div>
        </div>
      </section>

      <section className="solutions-list">
        <div className="container">
          {solutions.map((solution, index) => (
            <div key={index} className="solution-card">
              <div className="solution-header">
                <div className="solution-title-section">
                  <h2 className="solution-title">{solution.title}</h2>
                  <p className="solution-subtitle">{solution.subtitle}</p>
                </div>
                <p className="solution-description">{solution.description}</p>
              </div>

              <div className="solution-stats">
                {solution.stats.map((stat, idx) => (
                  <div key={idx} className="stat-item">
                    <div className="stat-value">{stat.value}</div>
                    <div className="stat-label">{stat.label}</div>
                  </div>
                ))}
              </div>

              <div className="solution-content">
                <div className="solution-section">
                  <h3 className="section-title">핵심 서비스</h3>
                  <ul className="features-list">
                    {solution.features.map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ul>
                </div>

                <div className="solution-section">
                  <h3 className="section-title benefit-title">고객 효과</h3>
                  <ul className="benefits-list">
                    {solution.benefits.map((benefit, idx) => (
                      <li key={idx}>{benefit}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Solutions;
